import { createOrUpdateTransaction } from "api/OnRamp/createOrUpdateTxn";
import ChoosePaymentsMethod from "components/onRamp/ChoosePaymentsMethod";
import InvalidPaymentMethods from "components/onRamp/InvalidPaymentMethods";
import { useOnrampContext } from "context/OnRamp";
import { captureEvent, captureFailure } from "posthog";
import { useEffect, useState } from "react";
import { OnrampType } from "types/OnRamp";
import { EventLevel, sendEvent } from "utils/events/handler";
import StateEnum from "../states";

const ChoosePaymentsMethodContainer = ({
  isLoadingMethods,
  setIsLoadingMethods,
  withdrawAllowedOnSelectedNetwork,
  selectedCurrency,
  paymentMethods,
  setCurrentState,
  fiatAmount,
  bankId,
  isKycPending,
  external,
  fromAmount,
  toAmount,
  externalNetwork,
  walletAddress,
  transactionId,
  orderId,
  setPaymentDetails,
  priceLock
}) => {

  const [loading, setLoading] = useState(false);

  const { cryptoCurrencyState, paymentMethodValidation, selectedPaymentMethod: spm } = useOnrampContext()
  const selectedPaymentMethod = spm.value
  const cryptoCurrency = cryptoCurrencyState.value

  const handleTransfer = async () => {

    const buyTransaction = await createOrUpdateTransaction(
      external ? OnrampType.ONRAMP_AND_WITHDRAW : OnrampType.ONRAMP,
      priceLock,
      bankId,
      selectedCurrency?.symbol,
      cryptoCurrency?.symbol,
      fromAmount,
      toAmount,
      selectedPaymentMethod,
      externalNetwork,
      walletAddress,
      undefined,
      undefined,
      orderId,
      transactionId
    ).catch((err) => {
      captureFailure(orderId ? "onramp_order_update_failed" : "onramp_order_failed", {
        payment_method: selectedPaymentMethod,
        fiat_currency: selectedCurrency?.symbol,
        crypto_currency: cryptoCurrency?.symbol,
        is_external_flow: external,
      });
    })
    if (!buyTransaction) {
      return;
    }

    const eventName = orderId ? "ORDER_UPDATED" : "ORDER_CREATED"
    sendEvent(eventName, EventLevel.INFO, { order_id: orderId ?? buyTransaction.data?.id })
    if (!orderId) {
      captureEvent("onramp_order_created", {
        payment_method: selectedPaymentMethod,
        fiat_currency: selectedCurrency?.symbol,
        crypto_currency: cryptoCurrency?.symbol,
        is_external_flow: external,
      });
    }

    setPaymentDetails(buyTransaction.data);

    return buyTransaction?.data?.id;
  };

  const navigate = (selectedPaymentMethod) => {
    const methodToStateMap = {
      "upi_transfer": StateEnum.UPI_PAYMENT_METHOD,
      "gpay_transfer": StateEnum.UPI_PAYMENT_METHOD,
      "paytm_transfer": StateEnum.UPI_PAYMENT_METHOD,
      "phonepe_transfer": StateEnum.UPI_PAYMENT_METHOD,
      "gpay_intent": StateEnum.INTENT_PAYMENT_METHOD,
      "paytm_intent": StateEnum.INTENT_PAYMENT_METHOD,
      "phonepe_intent": StateEnum.INTENT_PAYMENT_METHOD,
      "other_upi_intent": StateEnum.INTENT_PAYMENT_METHOD,
      "bank_transfer": StateEnum.BANK_PAYMENT_METHOD,
      "sepa_transfer": StateEnum.BANK_PAYMENT_METHOD,
      "van_transfer": StateEnum.VAN_PAYMENT_METHOD,
      "card_transfer": StateEnum.PAYMENT_METHOD_CHECKOUT
    };
  
    const newState = methodToStateMap[selectedPaymentMethod];
    if (newState) {
      spm.setValue(selectedPaymentMethod)
      setCurrentState(newState, true);
    }
  };
  
  const onClickMap = (categoryName, methodName) => {
    let selectedMethod = methodName;
  
    if (categoryName === "UPI") {
      selectedMethod = methodName.includes("intent") && methodName !== "other_upi_intent"
        ? methodName
        : "upi_transfer";
    }

    captureEvent("onramp_payment_method_selected", {
      payment_method: selectedMethod,
      category: categoryName,
    });
    navigate(selectedMethod);
  };

  useEffect(() => {
    if (withdrawAllowedOnSelectedNetwork && selectedPaymentMethod && paymentMethodValidation?.isEnabled) {
      navigate(selectedPaymentMethod);
    }

    if (selectedPaymentMethod && priceLock && !selectedPaymentMethod.includes("intent")) {
        setLoading(true);
        handleTransfer() 
        setLoading(false);
    }

    setIsLoadingMethods(
      selectedPaymentMethod ? !paymentMethodValidation : !paymentMethods
    );
    
  }, [paymentMethods, paymentMethodValidation]);
  

  // TODO: Implement default payment method if enabled payment method are only one

  return (
  <>
    <ChoosePaymentsMethod
      methods={paymentMethods}
      isLoadingMethods={isLoadingMethods}
      setCurrentState={setCurrentState}
      fiatAmount={fiatAmount}
      onClickMap={onClickMap}
      isKycPending={isKycPending}
      loading={loading}
      error={null}
    />
    {(paymentMethodValidation) && <InvalidPaymentMethods showDrawer={!paymentMethodValidation.isValid || !paymentMethodValidation.isEnabled} />}
    </>
  )
};

export default ChoosePaymentsMethodContainer;
